import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TComplianceMonitors } from './compliance-monitor.types';

function useComplianceMonitors(corporationIds: number[]) {
  const query = new URLSearchParams();
  query.append('corporationIds', corporationIds?.map(String).join(','));

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data: TComplianceMonitors;
    error: Error;
    mutate: KeyedMutator<TComplianceMonitors>;
    isLoading: boolean;
  } = useSWR(
    corporationIds.length > 0 ? `compliance-monitors/list?${query}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: isLoading ?? false,
  };
}

export { useComplianceMonitors };
